/* eslint-disable jsx-a11y/anchor-is-valid */
/* Used by Storefront */
import React from "react";
import { Modal } from "@clarkinc/zest-design-system";
import { LinkedResourceResult } from "~/common/Store/models/Category";
import ZestVideoModal from "~/common/VideoModal/ZestVideoModal";
interface Props {
  resource: LinkedResourceResult;
}
const VideoResource = ({
  resource
}: Props) => {
  const handleVideoClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    Modal.toggle("zestVideoModal");
  };
  return <div className="video fsr-item cursor-default overflow-visible" data-sentry-component="VideoResource" data-sentry-source-file="VideoResource.tsx">
      {resource.video && <>
          <a href="#" onClick={handleVideoClick} aria-label={`${resource.title} video`}>
            <div className="video-ui icon-play cursor-pointer mb-0 shadow-none" title={resource.title}>
              <img aria-hidden="true" src={resource.video?.poster} alt={resource.title} title={resource.title} />
            </div>
          </a>
          <span className="fsr-text">
            {resource.title}
            <p className="resource-brief">{resource.description}</p>
          </span>
          <ZestVideoModal video={resource.video} />
        </>}
    </div>;
};
export default VideoResource;